import Vue from 'vue';

import * as types from './mutation-types';

const mutations = {
  [types.SET_QUIZ_WRONG_RESULTS](state, quizWrongResults) {
    Vue.set(state, 'quizWrongResults', quizWrongResults);
  },

  [types.RESET_QUIZ_WRONG_RESULTS](state) {
    Vue.set(state, 'quizWrongResults', []);
  },

  [types.SET_PROFICIENCY_HISTORY](state, proficiencyHistory) {
    Vue.set(state, 'proficiencyHistory', proficiencyHistory);
  },

  [types.SET_DOMAINS_ELEMENTS](state, domainsElements) {
    /* eslint-disable no-param-reassign */
    domainsElements.forEach((item) => {
      item.answer_rate = (item.correct_count / item.total_count || 0) * 100;
    });
    Vue.set(state, 'domainsElements', domainsElements);
    /* eslint-enable no-param-reassign */
  },

  [types.SET_QUIZ_RESULT_CACHES](state, quizResultCaches) {
    Vue.set(state, 'quizResultCaches', quizResultCaches);
  },

  [types.SET_CAT_LIST](state, catList) {
    Vue.set(state, 'catList', catList);
  },

  [types.SET_RANKING_SCORES](state, rankingScores) {
    Vue.set(state, 'rankingScores', rankingScores);
  },

  [types.SET_USER_RANKING](state, userScores) {
    Vue.set(state, 'userRanking', userScores);
  },

  [types.SET_CAT_EXP_HISTORIES](state, catExpHistories) {
    Vue.set(state, 'catExpHistories', catExpHistories);
  },

  [types.SET_CAT_EXP_HISTORIES](state, catExpHistories) {
    Vue.set(state, 'catExpHistories', catExpHistories);
  },

  [types.SET_FLIGHT_BOX_REWARD_HISTORIES](state, flightBoxRewardHistories) {
    Vue.set(state, 'flightBoxRewardHistories', flightBoxRewardHistories);
  },

};

export default mutations;
